import React from "react";
import ReactToPrint from "react-to-print";
class InLanThanhToan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      choVayId: 0,
    };
  }
  static getDerivedStateFromProps(nextProp, prevState) {
    let { data } = nextProp;
    let { choVayId } = prevState;
    if (data && data.ChoVayId && data.ChoVayId !== choVayId) {
      return { choVayId: data.ChoVayId };
    }
    return null;
  }

  componentDidMount() {
    let { getInLanDongLai, data } = this.props;
    if(data.ChoVayId !==null && data.ChoVayId !==undefined)
    {
      getInLanDongLai({ chovayId: data.ChoVayId, isHienLaiGoc: 1 });
    }

  }
  render() {
    let { inlandonglai, data } = this.props;
    let { NoiDungIn } = inlandonglai;
    return (
      <div>
        <ReactToPrint
          trigger={() => (
            <button
              type="button"
              className="btn btn-new-main btn-checknew disk-mobile"
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-printer"></i>
              </span>
              In danh sách
            </button>
          )}
          content={() => this.componentRef}
          copyStyles={false}
        />
        <div style={{ display: "none" }}>
          <div ref={(el) => (this.componentRef = el)}>
            <div
              style={{ width: "100%", color: "#000000", padding: "10px" }}
              dangerouslySetInnerHTML={{ __html: NoiDungIn }}
            ></div>
          </div>

          {data.chovayId}
        </div>
      </div>
    );
  }
}
export default InLanThanhToan;
